module.exports = __webpack_public_path__ + "img/baptistmissionaustralia.1b5152f.png";